module.exports = __webpack_public_path__ + "static/media/what_riders_say.71948aa2.png";